document.addEventListener("DOMContentLoaded", function () {
  console.log("Cobranding script loaded");
  // Function to get the value of a specific cookie
  function getCookie(name) {
    let match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) {
      return decodeURIComponent(match[2]);
    }
    return null;
  }
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  }

  // Function to get the query parameter value
  function getQueryParameter(name) {
    let urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Get the cookie value
  let cookieValue = getCookie("cobranding");

  // Get the query parameter value
  let queryParamValue = getQueryParameter("sca_ref");

  if (queryParamValue) {
    setCookie("cobranding", queryParamValue, 30);
  }

  // Initialize the refValue to null
  let refValue = null;

  // Check if the cookie value is present and extract the ref value
  if (cookieValue) {
    let decodedValue = decodeURIComponent(cookieValue);
    let refMatch = decodedValue.match(/([^&]*)/);
    if (refMatch) {
      refValue = refMatch[1];
    }
  }

  // If the query parameter value is present, use it
  if (queryParamValue) {
    refValue = queryParamValue;
  }

  // If refValue is not null, compare it with the JSON data
  if (refValue) {
    let matchingEntry = cobranding.find((item) => item.ref === refValue);

    // If a matching entry is found, insert the image
    if (matchingEntry) {
      // Create the image element
      let img = document.createElement("img");
      img.src = matchingEntry.logo;
      img.alt = "Cobranding Logo";
      img.style = "object-fit: contain;height: 50px;margin-bottom: 20px;";

      // Find the first element with the class 'product__info'
      let productInfoElement = document.querySelector(".product__info");
      let productSubtitle = document.querySelectorAll(".product__text");
      productSubtitle[0].remove();

      if (productInfoElement) {
        // Insert the image as the first child
        productInfoElement.insertBefore(img, productInfoElement.firstChild);
      }

      let hero = document.getElementById("MainContent");

      if (matchingEntry.description) {
        let wrapper = document.createElement("div");
        wrapper.classList.add("cobranding");
        let imageWrapper = document.createElement("div");
        imageWrapper.appendChild(img.cloneNode(true));
        let description = document.createElement("div");
        description.innerHTML = matchingEntry.description;
        wrapper.appendChild(imageWrapper);
        wrapper.appendChild(description);
        insertAfter(hero.children[0], wrapper);
      }
    }
  }
});

function insertAfter(referenceNode, newNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
